import { CompactTabItem } from '../components/nav/CompactTabMenu/CompactTab';

import { DangerousCharacterRegex } from '../constants/regex';

import { LabelChannelCountModel } from './../models/label.model';

export const generateLabelVariantTypeChannelTabs = (
    counts?: LabelChannelCountModel,
) => {
    const t: CompactTabItem[] = [];
    if (counts) {
        Object.keys(counts).forEach((type) =>
            t.push({
                key: type,
                name: `${type} (${JSON.stringify(
                    counts[type as keyof LabelChannelCountModel],
                )})`,
            }),
        );
    }
    return t;
};

export const isSafeString = (value: string) =>
    !DangerousCharacterRegex.test(value.trim());

/**
 * Normalizes weight value to 0-100 range.
 * Handles both old format (decimal 0-1) and new format (0-100).
 * If value is > 1 or < -1, it's already in 0-100 range.
 */
export const normalizeWeight = (weight: number | null | undefined): number => {
    if (weight == null) return 0;
    return Math.abs(weight) > 1 ? weight : weight * 100;
};
